export const cn = {
    updateTip: {
        editForm: {
            title: '版本升级',
            subTitle: '提示：填写并提交下列信息，尽快会有工作人员在工作时段与您取得联系。',
            name: '姓名',
            name_p: '输入姓名',
            name_requied: '姓名不得为空',
            name_length_error: '姓名长度不得超出100字符',
            phone: '手机号码',
            phone_p: '输入手机号码',
            phone_required: '手机号码不得为空',
            phone_pattern_error: '手机号码格式错误',
            sms_p: '输入验证码',
            sms_pattern_error: '验证码为6位数字',
            sms_required: '验证码不得为空',
            send_sms: '发送验证码',
            resend: '重新发送',
            send_success: '系统刚刚通过短信将一个 6 位数的验证码发送到了以下号码：{phone}，该验证码10分钟内有效。',
            send_failed: '发送失败，请稍后尝试',
            company: '公司',
            company_p: '输入企业名称',
            company_required: '公司不得为空',
            company_name_length_error: '公司长度不得超出256字符',
            model: '职务',
            model_p: '输入您担任的职务',
            model_required: '职务不得为空',
            post_length_error: '职务长度不得超出100字符',
            submit: '提交申请',
            submit_success: '提交成功',
            submit_fail: '提交失败',
            success_sub: '我们将尽快和您联系，感谢您的耐心等待！',
            fail_sub: '抱歉，系统出错了。建议您通过客服系统沟通版本升级事宜，或稍后尝试。',
            got_it: '知道了',
        },
    },
    clueValidate: {
        9030119: '验证码错误或超时。',
    },
}

export const en = {
    updateTip: {
        editForm: {
            title: 'Edition Upgrade',
            subTitle: 'Tip: Submit the following information, and a staff member will contact you during working hours as soon as possible.',
            name: 'Name',
            name_p: 'Enter name',
            name_requied: 'Name cannot be empty',
            name_length_error: 'Name must not exceed 100 characters in length',
            phone: 'Contact Number',
            phone_p: 'Enter phone number',
            phone_required: 'Phone number cannot be empty',
            phone_pattern_error: 'Phone number format error',
            sms_p: 'Enter the code',
            sms_pattern_error: 'Verification code must be 6 digits',
            sms_required: 'Verification code must not be empty',
            send_sms: 'Send verification code',
            resend: 'Resend',
            send_success: 'The system has just sent a 6-digit verification code via SMS to the following number: {phone}. The verification code is valid for 10 minutes.',
            send_failed: 'Failed to send, please try later',
            company: 'Company',
            company_p: 'Enter enterprise name',
            company_required: 'Company cannot be empty',
            company_name_length_error: 'Company name must not exceed 256 characters in length',
            model: 'Position',
            model_p: 'Enter your position',
            model_required: 'Position cannot be empty',
            post_length_error: 'Position must not exceed 100 characters in length',
            submit: 'Submit',
            submit_success: 'Submitted successfully',
            submit_fail: 'Submission Failed',
            success_sub: 'We will contact you as soon as possible. Thank you for your patience.',
            fail_sub: 'Sorry, system error. You can communicate about the version upgrade through the customer service system on this page, or try leaving contact info later.',
            got_it: 'Got it',
        },
    },
    clueValidate: {
        9030119: 'The verification code is wrong or timed out.',
    },
}

export const jp = {
    updateTip: {
        editForm: {
            title: 'バージョンアップ',
            subTitle: 'ヒント: 次の情報を入力して送信してください。スタッフが なるべく早くに営業時間内にご連絡いたします。',
            name: '名前',
            name_p: '名前を入力',
            name_requied: 'コンテンツを空にすることはできません',
            name_length_error: '名前の長さは 100 文字を超えてはなりません',
            phone: '連絡先の詳細',
            phone_p: '電話番号を入力',
            phone_required: '電話番号を空にすることはできません',
            phone_pattern_error: '間違った電話番号の形式',
            sms_p: '認証コードを入力',
            sms_pattern_error: '認証コードは6桁です',
            sms_required: '確認コードを空にすることはできません',
            send_sms: '確認コードを送信する',
            resend: '再送',
            send_success: 'システムから SMS 経由で 6 桁の確認コードが次の番号に送信されました: {phone}。確認コードは 10 分間有効です。',
            send_failed: '送信できませんでした。後で試してください',
            company: '会社',
            company_p: '会社名を入力してください',
            company_required: '会社を空にすることはできません',
            company_name_length_error: '会社の長さは 256 文字を超えることはできません',
            model: '職名',
            model_p: 'タイトルを入力してください',
            model_required: '職名を空にすることはできません',
            post_length_error: 'タイトルの長さは 100 文字を超えてはなりません',
            submit: '申請書を提出する',
            submit_success: '提出しました',
            submit_fail: '提交失败',
            success_sub: 'できるだけ早くご連絡いたします。お待ちいただきありがとうございます。',
            fail_sub: 'エラーが発生しました。 カスタマー サービス システムを通じてバージョン アップグレードについて連絡するか、後で試すことをお勧めします。',
            got_it: 'わかりました',
        },
    },
    clueValidate: {
        90164051: '確認コードが間違っているか、タイムアウトになっています。',
    },
}

export const tw = {
    updateTip: {
        editForm: {
            title: '版本升級',
            subTitle: '提示：填寫並提交下列信息，儘快會有工作人員在工作時段與您取得聯繫。',
            name: '姓名',
            name_p: '輸入姓名',
            name_requied: '姓名不得為空',
            name_length_error: '姓名長度不得超出100字符',
            phone: '手機號碼',
            phone_p: '輸入手機號碼',
            phone_required: '手機號碼不得為空',
            phone_pattern_error: '手機號碼格式錯誤',
            sms_p: '輸入驗證碼',
            sms_pattern_error: '驗證碼為6位數字',
            sms_required: '驗證碼不得為空',
            send_sms: '發送驗證碼',
            resend: '重新發送',
            send_success: '系統剛剛通過簡訊將一個6位數的驗證碼發送到了以下號碼：{phone}，該驗證碼10分鐘內有效。',
            send_failed: '發送失敗，請稍後嘗試',
            company: '公司',
            company_p: '輸入企業名稱',
            company_required: '公司不得為空',
            company_name_length_error: '公司長度不得超出256字符',
            model: '職務',
            model_p: '輸入您擔任的職務',
            model_required: '職務不得為空',
            post_length_error: '職務長度不得超出100字符',
            submit: '提交申請',
            submit_success: '提交成功',
            submit_fail: '提交失敗',
            success_sub: '我們將盡快和您聯繫，感謝您的耐心等待！',
            fail_sub: '抱歉，系統出錯了。建議您通過客服系統溝通版本升級事宜，或稍後嘗試。',
            got_it: '知道了',
        },
    },
    clueValidate: {
        9030119: '驗證碼錯誤或超時。',
    },
}
